import { FormattedMessage } from "react-intl";
import ManageTranscriptionTileIcon from "../../../components/Common/SvgIcons/ManageIcons/ManageTranscriptionTileIcon";
import { colors } from "../../stripeColors";
import { contentBulkUpload } from "./contentBulkUpload";
import { createShotclasses } from "./createShotclasses";
import { createTrainingType } from "./createTrainingType";
import { manageTranscription } from "./manageTranscription";
import { myDrafts } from "./myDrafts";
import { publishedByMe } from "./publishedByMe";
import { publishedByOthers } from "./publishedByOthers";

export const manage = {
  name: <FormattedMessage id="MANAGE_SHOTCLASSES" />,
  path: (tenantName) => `/${tenantName}/manage`,
  buttons: (navigate, tenantName) => [
    // {
    //   key: 1,
    //   label: createTrainingType.label,
    //   path: createTrainingType.path(tenantName),
    //   icon: createTrainingType.icon,
    //   onClick: () => navigate(createTrainingType.path(tenantName)),
    // },
    {
      key: 2,
      label: createShotclasses.label,
      path: createShotclasses.path(null, null, tenantName),
      icon: createShotclasses.icon,
      onClick: () => navigate(createShotclasses.path(null, null, tenantName)),
    },
    {
      key: 3,
      label: contentBulkUpload.label,
      path: contentBulkUpload.path(tenantName),
      icon: contentBulkUpload.icon,
      onClick: () => navigate(contentBulkUpload.path(tenantName)),
    },
  ],
  tiles: (navigate, tenantName, val1, val2, val3, val4) => [
    {
      key: 1,
      label: myDrafts.label,
      path: myDrafts.path(tenantName),
      value: val1 || 0,
      color: colors.green,
      onClick: () => navigate(myDrafts.path(tenantName)),
    },
    {
      key: 2,
      label: publishedByMe.label,
      path: publishedByMe.path(tenantName),
      value: val2 || 0,
      color: colors.purple,
      onClick: () => navigate(publishedByMe.path(tenantName)),
    },
    {
      key: 3,
      label: publishedByOthers.label,
      path: publishedByOthers.path(tenantName),
      value: val3 || 0,
      color: colors.red,
      onClick: () => navigate(publishedByOthers.path(tenantName)),
    },
    {
      key: 4,
      label: manageTranscription.label,
      path: manageTranscription.path(tenantName),
      value: val4 || 0,
      color: colors.orange,
      icon: (fill) => <ManageTranscriptionTileIcon fill={fill} />,
      onClick: () => navigate(manageTranscription.path(tenantName)),
    },
  ],
};
